module.exports = __webpack_public_path__ + "img/2.976c9495.png";